import { CreatedInterfaces } from '../../interfaces';
import usePatchRequest from '../utils/usePatchRequest';

const resource = 'card-affinity-group-update';

const useUpdateCardAffinityGroup = (cardAffinityGroupId: string) => {
  const { patchData, patchError, patchLoading, executePatch }  = usePatchRequest<CreatedInterfaces<typeof resource>>({
    path: `v1/card_affinity_groups/${cardAffinityGroupId}`
  })

  return {
    data: patchData,
    loading: patchLoading,
    error: patchError,
    executePatch
  }
}

export default useUpdateCardAffinityGroup;